import { BigNumber } from 'bignumber.js';
import { min } from 'lodash-es';

/***
 ** Re-calculates claim to make it evenly divisible by the number of shares|options
 ** Also makes sure it stays within the shares limit provided.
 */
export function claimRecalc(
  claim: BigNumber,
  pricePerUnit: BigNumber,
  limit: number,
): { newUnits: BigNumber; newClaim: BigNumber } {
  const units = new BigNumber(claim).div(pricePerUnit).integerValue(BigNumber.ROUND_FLOOR);
  const newUnits = new BigNumber(min([limit, units.toNumber()]) ?? 0);
  const newClaim = new BigNumber(newUnits).times(pricePerUnit);
  return { newUnits, newClaim };
}
